import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import { FormStore } from "../../stores/FormStore";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {IWindow} from "../../index";
// import {UserForm} from "./UserPageModel";
// import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Col, Container, Row} from "reactstrap";
 import { Button} from "reactstrap";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import _ = require("lodash");
import DropZone, {DropZoneStore} from "../../stores/DropZoneStore";
// import { Extension } from "typescript"; 

// import {getEnumOptions} from "../../utils/helper";
// import {enums} from "../../Enums";

 import {LGAPicker} from "../form/fields/LGAPicker";
 // import {FederalConstituencyPicker} from "../form/fields/FederalConstituencyPicker";
 // import {StateConstituencyPicker} from "../form/fields/StateConstituencyPicker";
 // import {WardPicker} from "../form/fields/WardPicker";
 // import {SenatorialDistrictPicker} from "../form/fields/SenatorialDistrictPicker";

 // import {PollingUnitPicker} from "../form/fields/PollingUnitPicker";  
 import {ToastContainer} from 'react-toastify';
 import 'react-toastify/dist/ReactToastify.css';
import { toast} from 'react-toastify';
const qs = require('qs');

const IWindow: IWindow = (window as IWindow);

/* =============== user form ======================================= */

 
export class ElectionPollingUnitResultFormData {
    @observable user_level = "polling_unit"; // IWindow.initialState.user.level;
    @observable party_competitor_party_result = 1;
    @observable election_id = null;
    @observable party_id = null;
    @observable candidate_id = null;
    @observable election_position_id = null;
	@observable obj_data_value = '';
  //  @observable number_of_votes  : number | null = null;
   @observable number_of_votes  : string | null = null; // : number | null = null;
    @observable obj_data = Array<any>();  // [];
    @observable accredited_voters : number | null = null;
    @observable pu_registered_voters  : number | null = null;
    @observable disputed_voters  : number | null = null;
    @observable rejected_voters  : number | null = null;
    @observable user_defined_1  : number | null = null;
    @observable user_defined_2  : number | null = null;
    @observable verified_voters_from_cr  : number | null = null;
    @observable level = 'polling_unit';
    @observable state_id = '';
    @observable senatorial_district_id = '';
    @observable federal_constituency_id = '';
    @observable state_constituency_id = '';
    @observable local_government_area = null;
    @observable local_government_area_id = '';
    @observable ward_id = '';
    @observable election_polling_unit_id =  null;
	@observable upload_id = null;
	@observable result_photo  = {}; // : string | null = null;
	
	
    
}


export class PartyElectionPollingUnitResultForm extends CrudForm {
    @observable registeredVoter  : any;
    modelName = 'ElectionPollingUnitResult';
    
    party_id = IWindow.initialState.user.party_id;
    @observable nofvotes = false;
    @observable avoters = false;
    @observable rvoters = false;
    @observable dvoters = false;
    @observable regvoters = false;
	
	@observable party_candidates: [];
	
	@observable obj = Array<any>();  // [];
	@observable number_of_votes_array  = []; // : number | null = null;
	
	dropZoneStore = new DropZoneStore();
	
	djsConfig = {
        maxFilesize: 1,
        acceptedFiles: "image/jpeg,image/png,image/gif",
        maxSize: 1024,
        paramName: "file_upload",
        params: {
            file_field: 'result_photo',
        }
    };
	
	componentConfig = {
        postUrl: 'upload',
    }; 
	 
	@observable electionSubscription = {
        registeredVoters : 0,
        accreditedVoters : 0,
        rejectedVoters   : 0,
        disputedVoters   : 0,
        election_polling_unit : 0,
        election_polling_unit_subscriptions : 0,
        election_unsubscribed_polling_unit : 0,
        federal_constituencies: 0,
        local_government_areas: 0,
        senatorial_districts: 0,
        state_constituencies: 0,
        states: 0,
        wards: 0,
        incidence_count: 0,
        election_candidates_votes: [],
        pollingUnitName: [],
        pollingUnitCode: [],
        pollingUnitState: [],
        total_votes: [],
        grandTotal: [],
        election_positions: [],
        check_list_count: [],
       
    };	

    constructor(props: any) {
        super(props);
        this.onKeyPress = this.onKeyPress.bind(this);
   }
   
    eventHandlers = {

        error: (file: any, response: any) => {
            //const message = response.message ? 'error in upload' : response;
            //this.props.rootStore.messageStore.showErrorMessage(message);
            this.dropZoneStore.progress = 0;
            this.dropZoneStore.uploadButtonEnabled = true;
        },
        success: (file: any, response: any) => {
            this.dropZoneStore.progress = 0;
            this.dropZoneStore.uploadButtonEnabled = true;
            this.formStore.setValue('upload_id', response.upload_id);
            this.formStore.setValue('result_photo', response);
            // update user profile to link image to user
            //this.postData(this.formStore.data);
        },
    };
   
   onClickButton(event: any) {
        event.preventDefault();
    };
   
   onInputchange(i: any,e: any) {
   
   // console.log("i->" + i);
  //  console.log("e->" + e.target.value);
	  
	this.obj[i] = e.target.value;
	
	this.formStore.setValue('obj_data', this.obj);	
	this.formStore.setValue('obj_data_value', btoa(JSON.stringify(Object.assign({}, this.obj))) );	
	this.formStore.setValue('number_of_votes', btoa(JSON.stringify(Object.assign({}, this.obj))) );	
	
	// console.log("vl->" + btoa(JSON.stringify(Object.assign({}, this.obj)))  );
	 
  };
  
   onChangeElection = () => { 
   console.log('call change event' + this.formStore.getValue('election_polling_unit_id'));
        this.formStore.getValue('election_id') && (IWindow.initialState.user.polling_unit_id || this.formStore.getValue('election_polling_unit_id'))  &&
          api.electionPollingUnitAddResult.getElectionPartyListAction({
            election_id: this.formStore.getValue('election_id'),
			polling_unit_id:  (IWindow.initialState.user.polling_unit_id || this.formStore.getValue('election_polling_unit_id')),
        }).then((data: any) => {
             this.electionSubscription = data;
			 
			 console.log('election subscription - ' + this.electionSubscription);
			 
			 this.party_candidates = data.election_candidates_votes;
			 
			 console.log('party candidate - ' + this.party_candidates);
			 
             /*this.party_candidates = data.election_candidates_votes.filter((candidate: any) => {
                return candidate.party_id == (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.formStore.getValue('party_id') );
             }); */
			

             

             
        });
    };
	
	
   
   getCandidateRow = (candidate: any,totalvotes: any,index: any) => {
		
        return <tr key={'candidate-row' + candidate.id}>
			
			<td>
                <div className=""> 
				{ 
					candidate.party_logo && candidate.party_logo.url ?
				<img src={candidate.party_logo.url} style={{width: 50, height: 50}}/> :
                                    <img src="https://fakeimg.pl/50x50/"/>                
									}
									</div>
                
            </td>
			
            <td>
                <div className="">
                    {candidate.party_name}
                </div>
            </td>
			<td>
				<div className="">{candidate.name}
                </div>
			</td>
            <td className="text-center">
                <div className="icon-candidates text-success my-1"></div>
                <div className="comp-position">
                    <div className="text-center">
                        <small>{candidate.position_name}</small>
                    </div>
                    <div className="text-center">
                        <small>{candidate.region_name}</small>
                    </div>
                </div>
            </td>
            <td><span className="" >
			
			</span></td>
			<td className="text-center "  >
			{
				 <input
					name='number_of_votes1[]'
					placeholder='Enter Vote'
				    type="number"
					onChange={e => this.onInputchange(candidate.id + "_" + candidate.party_id , e)} 
					
				/>
		  
			//   <Field
			//		key="{candidate.id}"
            //        type="number"
            //        label=""
			//		name="number_of_votes"
			//		placeholder="Enter Vote"
			//		component={Input}
            //        required={true}
			//		store={this.formStore}
            //       min="0"
            //      //  onChange={e => this.onInputchange(index, e)} 
            //    />
			}
			
			</td>
			<td className="text-center">
                <div className="comp-votes">
                    <span></span>
                </div>
            </td>
			
			
        </tr>
		
		
		
    };
   

     onKeyPress = (value: any) => {

        const validate = /^[0-9\b]+$/;
        if (!validate.test(value) && value) {
         //   this.formStore.setValue('number_of_votes', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('accredited_voters', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('pu_registered_voters', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('disputed_voters', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('rejected_voters', Number(value.substring(0, value.length - 1)));
            
        }

        if (this.formStore.getValue('rejected_voters') > this.registeredVoter) {
            // this.formStore.setValue('number_of_votes', Number(this.registeredVoter));
            if(!this.regvoters)
             toast.error('You are adding more than number of voters, kindly note that');
 
            this.regvoters = true;
                 
            
         }

      /*  if (this.formStore.getValue('number_of_votes') > this.registeredVoter) {
           // this.formStore.setValue('number_of_votes', Number(this.registeredVoter));
           if(!this.nofvotes)
            toast.error('You are adding more than number of voters, kindly note that');

           this.nofvotes = true;
                
           
        } */

        if (this.formStore.getValue('accredited_voters') > this.registeredVoter) {
           // this.formStore.setValue('accredited_voters', Number(this.registeredVoter));
           if(!this.avoters)
            toast.error('You are adding more than number of voters, kindly note that');

           this.avoters = true;
        }

        if (this.formStore.getValue('pu_registered_voters') > this.registeredVoter) {
          //  this.formStore.setValue('pu_registered_voters', Number(this.registeredVoter));
          if(!this.rvoters)
            toast.error('You are adding more than number of voters, kindly note that');

          this.rvoters = true;
        }

        if (this.formStore.getValue('disputed_voters') > this.registeredVoter) {
         //   this.formStore.setValue('disputed_voters', Number(this.registeredVoter));
         if(!this.dvoters)
            toast.error('You are adding more than number of voters, kindly note that');

         this.dvoters = true;
        }
    };
 

    loadMoreData(props: any, module: any) {
	
		
		 console.log("election id",Number(window.localStorage.getItem('election_id')));
		 console.log("polling_unit_id",Number(window.localStorage.getItem('polling_unit_id')));
		 console.log("level",window.localStorage.getItem('level'));
		 console.log("election_position_id",window.localStorage.getItem('election_position_id'));
	
		 if (Number(window.localStorage.getItem('election_id')) > 0) {
		 
//		 	this.formStore.setValue('election_id', window.localStorage.getItem('election_id'));    
		 	this.formStore.setValue('election_position_id', window.localStorage.getItem('election_position_id'));    
		 	this.formStore.setValue('state_id', window.localStorage.getItem('state_id'));    
		 	this.formStore.setValue('local_government_area_id', window.localStorage.getItem('local_government_area_id'));    
		 
		 IWindow.initialState.user.polling_unit_id = window.localStorage.getItem('polling_unit_id');
		 
		 console.log("iw poll",IWindow.initialState.user.polling_unit_id );
			this.formStore.setValue('level', window.localStorage.getItem('level'));    
			this.formStore.setValue('user_level', window.localStorage.getItem('level'));    
			this.formStore.setValue('ward', window.localStorage.getItem('ward'));    
			this.formStore.setValue('ward_id', window.localStorage.getItem('ward_id'));
			
			this.formStore.setValue('polling_unit', window.localStorage.getItem('polling_unit'));
			this.formStore.setValue('polling_unit_id', window.localStorage.getItem('polling_unit_id'));
//			this.formStore.setValue('election_polling_unit_id', window.localStorage.getItem('election_polling_unit_id'));
			this.formStore.setValue('party_id', IWindow.initialState.user.party_id);
		//	this.onChangeElection();
		}
	
	if (Number(window.localStorage.getItem('election_id')) > 0) {
            this.formStore.setValue('election_id', Number(window.localStorage.getItem('election_id')));
            this.getPollingUnitByUserPollingUnitId();
        } else {
            this.formStore.setValue('election_id', null);
        }
       
    }

    getPollingUnitByUserPollingUnitId = () => {
        if(!IWindow.initialState.user.polling_unit_id || !this.formStore.getValue('election_id')){
           return;
        }
        api.electionPollingUnit.getListAction({
            page:0,
            filters: {
                polling_unit_id: this.formStore.getValue('polling_unit_id'), // IWindow.initialState.user.polling_unit_id,
                election_id: this.formStore.getValue('election_id')
            }
        }).then((data: any) => {
		console.log('inside pollingunig');
            if(data && data.length){
               this.formStore.setValue('election_polling_unit_id', data[0].id);
             }
        });

    };

    stateDropDown() {
        return (!(['senatorial_district', 'federal_constituency', 'state_constituency', 'polling_unit'])
            .includes(this.formStore.getValue('level'))) ?

            <Field
                key={"form_state_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                label="State"
                name="state_id"
                placeholder="Select State"
                component={Select}
                loadOptions={() => {
                    return api.state.getListAction({
                        filters: {
                            election_id: this.formStore.getValue('election_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={() => {
					// this.onChangeElection();
                  //  this.formStore.setValue('senatorial_district_id', null);
                  //  this.formStore.setValue('federal_constituency_id', null);
                  //  this.formStore.setValue('local_government_area_id', null);
                  //  this.formStore.setValue('state_constituency_id', null);
                  //  this.formStore.setValue('ward_id', null);
                //    this.formStore.setValue('election_polling_unit_id', null);
                }}
            /> : '';
    };

    senatorialDistrictDropDown() {
        return this.formStore.getValue('level') === 'senatorial_district' ?

            <Field
                key={"form_senatorial_district_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                label="Senatorial District"
                name="senatorial_district_id"
                placeholder="Select Senatorial Districts"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.senatorialDistrict.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
				//	this.onChangeElection();
                 //   this.formStore.setValue('ward_id', null);
                //    this.formStore.setValue('local_government_area_id', null);
                //    this.formStore.setValue('election_polling_unit_id', null);
                }}
            /> : '';
    }

    federalConstituencyDropDown() {
        return this.formStore.getValue('level') === 'federal_constituency' ?
            <Field
                label="Federal Constituency"
                key={"form_federal_constituency_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                name="federal_constituency_id"
                placeholder="Select Federal Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.federalConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
				//	this.onChangeElection();
                //    this.formStore.setValue('ward_id', null);
                //    this.formStore.setValue('local_government_area_id', null);
                //    this.formStore.setValue('election_polling_unit_id', null);
                }}
            /> : '';
    }

    lgaDropDown() {
        return (!((['ward', 'state_constituency'])
            .includes(this.formStore.getValue('level')))  &&
        (this.formStore.getValue('state_id') ||
            this.formStore.getValue('senatorial_district_id') ||
            this.formStore.getValue('federal_constituency_id')
        ) ) ?
            <Field
                key={"form_local_government_area_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id') +
                this.formStore.getValue('state_id') +
                this.formStore.getValue('senatorial_district_id') +
                this.formStore.getValue('federal_constituency_id')
                }
                label={"LGA"}
                placeholder={"LGA"}
                name="local_government_area"
                store={this.formStore}
                multi={false}
                component={LGAPicker}
                returnObject={false}
                filters={{
                    election_id: this.formStore.getValue('election_id'),
                    state_id: this.formStore.getValue('state_id'),
                    senatorial_district_id: this.formStore.getValue('senatorial_district_id'),
                    federal_constituency_id: this.formStore.getValue('federal_constituency_id'),
                    election_position_id: this.formStore.getValue('election_position_id'),
                    level: this.formStore.getValue('level'),
                    candidateIds: [this.formStore.getValue('candidate_id')],
                    party_id: this.formStore.getValue('party_id'),
                    user_level: this.formStore.getValue('user_level'),
                }}
                onChange={(value: any) => {
				//	this.onChangeElection();
                    if(value){
                        this.formStore.setValue('local_government_area_id', value.id);
                    }
                //    this.formStore.setValue('ward_id', null);
                //    this.formStore.setValue('election_polling_unit_id', null);
                }}

            /> : '';
    };

    stateConstituencyDropDown() {
        return this.formStore.getValue('level') === 'state_constituency' ?

            <Field
                label="State Constituency"
                key={"form_state_constituency_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                name="state_constituency_id"
                placeholder="Select State Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.stateConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
				//	this.onChangeElection();
                   // this.formStore.setValue('ward_id', null);
                }}
            /> : '';
    }

    wardsDropDown() {
        return  (this.formStore.getValue('local_government_area_id') ||
            this.formStore.getValue('state_constituency_id') ||
            this.formStore.getValue('level') === 'polling_unit') ?

        <Field
            key={"form_ward_id_" +
            this.formStore.getValue('election_id') +
            this.formStore.getValue('party_id') +
            this.formStore.getValue('election_position_id') +
            this.formStore.getValue('level') +
            this.formStore.getValue('candidate_id') +
            this.formStore.getValue('state_id') +
            this.formStore.getValue('senatorial_district_id') +
            this.formStore.getValue('federal_constituency_id') +
            this.formStore.getValue('state_constituency_id') +
            this.formStore.getValue('local_government_area_id')
            }
            label="Ward"
            name="ward_id"
            placeholder="Select Ward"
            component={Select}
            loadOptions = { () => {
                return api.ward.getListAction({
                    filters : {
                        state_id: this.formStore.getValue('state_id'),
                        local_government_area_id: this.formStore.getValue('local_government_area_id'),
                        state_constituency_id: this.formStore.getValue('state_constituency_id'),
                        election_position_id: this.formStore.getValue('election_position_id'),
                        level: this.formStore.getValue('level'),
                        candidateIds: [this.formStore.getValue('candidate_id')],
                        party_id: this.formStore.getValue('party_id'),
                        user_level: this.formStore.getValue('user_level'),
                        no_position: (this.formStore.getValue('level') === 'polling_unit') ? 1 : null,
                    }
                });
            }}
            store={this.formStore}
            onChange={() => {
			// this.onChangeElection();
              //  this.formStore.setValue('election_polling_unit_id', null);
            }}
        /> : ''
    }
	
	 onLoadElectionsData = () => {
        return api.election.getListAction({
            filters: {
                party_id: this.party_id,
            }
        }).then((data: any) => {
            if (data && data.length) {
                this.formStore.setValue('election_id', data[0].id);
                this.onChangeElection();
            }
            return data;
        });
    };
	
	 onLoadElectionsPositionData = () => {
        
		  return api.electionPosition.getListAction({
				filters: {
					election_id: this.formStore.getValue('election_id'),
					other_party_id: (this.party_id != this.formStore.getValue('party_id') ?
						this.formStore.getValue('party_id') : null),
					party_id: this.party_id
				}
			}).then((data: any) => {
		if (data && data.length) {
			this.formStore.setValue('election_id', data[0].id);
		//	this.onChangeElection();
		}
            return data;
        });
							
							
    };

    renderFields() {
        return (
            <>
				<ToastContainer autoClose={5000} />
                <Field
                    key={"form-field-election-id"}
                    placeholder="Select Election"
                    name="election_id"
                    component={Select}
                    required={true}
					 loadOptions={this.onLoadElectionsData}
                   //  loadOptions={api.election.getListAction}
				  /* loadOptions={() => {
                            return api.election.getListAction({
                                filters: {
                                   
                                    party_id: this.party_id
                                }
                            });
                        }}*/
				   
				   
                    store={this.formStore}
                    onChange={() => {
                       // this.getPollingUnitByUserPollingUnitId();
                      //  this.formStore.setValue('party_id', null);
                        this.formStore.setValue('candidate_id', null);
						this.onChangeElection();
                    }}
                />

                {
				// this.formStore.getValue('election_id') ?

                //    <Field
                //        key={'form_party_id_' + this.formStore.getValue('election_id')}
                //        name="party_id"
                //        placeholder="Select Party"
                //        component={Select}
                //        disabled={!this.formStore.getValue('election_id')}
                //        required={true}
                //        loadOptions={() => {
                //            return api.party.getListAction({
                //                filters: {
                //                    election_id: this.formStore.getValue('election_id'),
                //                    include_competitor_party: 1
                //                }
                //            }).then((data: any) => {
                //                return data.data;
                //            });
                //        }}
                //        store={this.formStore}
                //        onChange={() => {
                //            this.formStore.setValue('candidate_id', null);
                //            //this.formStore.setValue('election_position_id', null);
                //        }}
                //    /> : ''
                }

                {
				
				this.formStore.getValue('election_id') ?

                    <Field
                        key={'form_election_position_id_' + this.formStore.getValue('election_id') + this.formStore.getValue('party_id')}
                        name="election_position_id"
                        placeholder="Select Position"
                        component={Select}
                        disabled={!this.formStore.getValue('election_id')}
                        required={true}
						// loadOptions={this.onLoadElectionsPositionData}
						
                        loadOptions={() => {
                            return api.electionPosition.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    other_party_id: (this.party_id != this.formStore.getValue('party_id') ?
                                        this.formStore.getValue('party_id') : null),
                                    party_id: this.party_id
                                }
                            });
                        }}
                        returnObject={true}
                        extraKey={'level'} 
                        store={this.formStore}
                        onChange={(item: any) => {
                            this.formStore.setValue('level', null);
                            if (item) {
                                this.formStore.setValue('level', item.extraKey);
                            }
                         //   this.formStore.setValue('candidate_id', null);
                         //   this.formStore.setValue('state_id', null);
                         //   this.formStore.setValue('senatorial_district_id', null);
                         //   this.formStore.setValue('federal_constituency_id', null);
                         //   this.formStore.setValue('local_government_area_id', null);
                         //   this.formStore.setValue('state_constituency_id', null);
                        //    this.formStore.setValue('ward_id', null);
						//	this.onChangeElection();
							
							// whizent
						//	this.getPollingUnitByUserPollingUnitId();
							
							return IWindow.initialState.user.polling_unit_id && api.electionPollingUnit.getVoteListPollingAction({
                                  filters: {
                                     polling_unit_id : IWindow.initialState.user.polling_unit_id,
                                     election_id: this.formStore.getValue('election_id'), 
									 local_government_area_id: 0,
									 ward_id: 0,
									 election_polling_unit_id:0,
                                   }
                                }).then((data: any) => {
                                    if(data && data.length){
                                       this.registeredVoter = data[0].registered_voters;
                                      // this.formStore.setValue('number_of_votes',data[0].registered_voters);
                                       this.formStore.setValue('accredited_voters', data[0].registered_voters);
                                       this.formStore.setValue('pu_registered_voters', data[0].registered_voters);
                                     //  this.formStore.setValue('disputed_voters', data[0].registered_voters);
                                       // this.formStore.setValue('rejected_voters', data[0].registered_voters);
                                       
                                    }
                                });
							
							
							
							
							
							
							
							
                        }}
                    />
                    : ''
                }

                {this.formStore.getValue('party_id') && this.formStore.getValue('election_id') && !IWindow.initialState.user.polling_unit_id ?

                    <Field
                        key={'form_candidate_filter_election_result_' +
                        this.formStore.getValue('party_id') + '_election_id' +
                        this.formStore.getValue('election_id') + '_election_position_id' +
                        this.formStore.getValue('election_position_id')}
                        name="candidate_id"
                        placeholder="Select Candidate"
                        component={Select}
                        disabled={!this.formStore.getValue('party_id')}
                        required={true}
                        loadOptions={() => {
                            return api.candidate.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    party_id: this.formStore.getValue('party_id'),
                                    election_position_id: this.formStore.getValue('election_position_id'),
                                }
                            });
                        }}
                        store={this.formStore}
                        returnObject={true}
                        onChange={() => {
                        }}
                    /> : ''
                }

                {
                    this.formStore.getValue('level') && !IWindow.initialState.user.polling_unit_id ?
                        <>
                            {this.stateDropDown()}
                            {this.senatorialDistrictDropDown()}
                            {this.federalConstituencyDropDown()}
                            {this.formStore.getValue('level') !== 'state_constituency' ? this.lgaDropDown() : ''}
                            {this.stateConstituencyDropDown()}
                            {this.wardsDropDown()}

                        </> : ''
                }
                {
                    !IWindow.initialState.user.polling_unit_id &&
                    this.formStore.getValue('election_id') /* &&
                    this.formStore.getValue('candidate_id') */ ?
                        <Field
                            key={"form_election_polling_unit_id_" + this.formStore.getValue('election_id') +
                            this.formStore.getValue('ward_id') + this.formStore.getValue('election_position_id') 
                            + this.formStore.getValue('election_polling_unit_id') + this.formStore.getValue('local_government_area_id')
                            }
                            label={"Polling Unit"}
                            placeholder={"Polling Unit"}
                            name="election_polling_unit_id"
                            store={this.formStore}
                            component={Select}

                            loadOptions={() => {
                               return api.electionPollingUnit.getListAction({
                                    filters: {
                                        election_id: this.formStore.getValue('election_id'),
                                        ward_id: this.formStore.getValue('ward_id'),
                                        local_government_area_id : this.formStore.getValue('local_government_area_id'),
                                        election_polling_unit_id: this.formStore.getValue('election_position_id'),
                                        no_position_candidate_id: /* this.formStore.getValue('level') == 'polling_unit' ?
                                              this.formStore.getValue('candidate_id') : null */ null
                                    }
                                })
                            }}
 
                            onChange={(item: any) => {
							this.onChangeElection();
                                return api.electionPollingUnit.getVoteListAction({
                                  filters: {
                                     election_polling_unit_id : this.formStore.getValue('election_polling_unit_id'),
                                     local_government_area_id : this.formStore.getValue('local_government_area_id'),
                                     ward_id : this.formStore.getValue('ward_id'),
                                     election_id: this.formStore.getValue('election_id'),
                                   }
                                }).then((data: any) => {
                                    if(data && data.length){
                                       this.registeredVoter = data[0].registered_voters;
                                      // this.formStore.setValue('number_of_votes',data[0].registered_voters);
                                       this.formStore.setValue('accredited_voters', data[0].registered_voters);
                                       this.formStore.setValue('pu_registered_voters', data[0].registered_voters);
                                      // this.formStore.setValue('disputed_voters', data[0].registered_voters);
                                       // this.formStore.setValue('rejected_voters', data[0].registered_voters);
                                       
                                    }
                                });
                            }}

                        /> : ''
                }
 
                    
                
 
                 
 
                <Field
                    label="Polling Unit Accredited Voters"
                    name="accredited_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />

                <Field
                    label="Registered Voters at Polling Unit"
                    name="pu_registered_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />
 
                <Field
                    label="Polling Unit Disputed Votes"
                    name="disputed_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />  

                <Field
                    label="Polling Unit Rejected Votes"
                    name="rejected_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />
				
				 
				<DropZone
                    store={this.dropZoneStore}
                    componentConfig={this.componentConfig}
                    djsConfig={this.djsConfig}
                    eventHandlers={this.eventHandlers}
                >
                    <Button className="image-uploader" onClick={this.onClickButton}>
                        {
                            this.formStore.getValue('result_photo') && this.formStore.data.result_photo.url ?
                                <img src={this.formStore.data.result_photo.url}
                                     style={{width: 120, height: 120}}/> : 'Click here to Upload'
                                
                        }
                    </Button>
                    <div
                        className="form-progress-bar"
                        style={{width: `${this.dropZoneStore.progress}%`}}
                    />
                </DropZone>

				
				{ /* Voting Value */ }
				<Field
				    label="Voting Value"
                    name="number_of_votes"
                    component={Input}
                    type="hidden"
                    store={this.formStore}
					onChange={this.onKeyPress}
                 /> 
	
				<table className="table table-hover border-top bgcolornw">
												<thead>
													<th>Logo</th>
													<th>Party</th>
													<th>Candidate Name</th>
													<th className="text-center">Postions</th>
													<th></th>
													<th className="text-center">Votes</th>
													<th className="text-center"></th>
												</thead>
                                                <tbody>
												{
													
												
                                                    this.formStore.getValue('election_id') && this.party_candidates &&
                                                    this.party_candidates.length ?
                                                        this.party_candidates.map((candidate: any,index) => {
                                                            return (
                                                                this.getCandidateRow(candidate,this.electionSubscription.total_votes,index)
                                                            );
                                                        }, this)
                                                        : <tr>
                                                            <td colSpan={7}>
                                                                <div className="comp-candidate">No Candidates</div>
                                                            </td>
                                                        </tr>
                                                }
												
												
                                                        
                                                
												
																												

                                                </tbody>
                                            </table>

                {/*<Field
                    label="Verified voters from CR."
                    name="verified_voters_from_cr"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                />

                <Field
                    label="User Defined #2"
                    name="user_defined_1"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                />

                <Field
                    label="User Defined #1"
                    name="user_defined_2"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                />*/}
            </>
        );
    }
}
 
/* =============== user form end =================================== */
 
 
 
export class PartyElectionPollingUnitResultFilterForm {
    @observable election_id = null;
    @observable user_party_id = IWindow.initialState.user.party_id;
    @observable election_position_id = null;
    @observable state_id = null;
    @observable local_government_area_id = null;
    @observable ward_id = null;
    @observable federal_constituency_id = null;
    @observable senatorial_district_id = null;
    @observable state_constituency_id = null;
    @observable level = null;

	
     candidateIds = null;
}



export class PartyElectionPollingUnitResultList extends CrudList /* CrudList */ {
    modelName = 'PartyElectionPollingUnit';
    @observable election: any = null;
    @observable candidates = null;
    @observable userForm: PartyElectionPollingUnitResultForm;
    @observable polluserForm:  ElectionPollingUnitResultFormData;
    @observable formStore: FormStore<any>;
	
	constructor(props: any) {
        super(props);
        this.handleExport = this.handleExport.bind(this);
     
    }
    
    getElectionDetails(electionId: any) {
        this.election = null;
        
        if(electionId){
            api.election.getDetailAction(electionId).then((data: any) => {
                this.election = data;
            })
        }
    }

    getCandidates() {
       api.candidate.getListAction({
            filters: {
                election_id: this.filterFormStore.getValue('election_id'),
                party_id: this.filterFormStore.getValue('user_party_id'),
                election_position_id: this.filterFormStore.getValue('election_position_id')
            }
        }).then((data: any) => {
           this.candidates = data;
           this.filterFormStore.setValue('candidateIds', _.map(data, 'id'));
        })
    }

    senatorialDistrictDropDown() {
        return this.filterFormStore.getValue('level') === 'senatorial_district' ?
            <Col md={2} lg={3} xl>
                <Field
                    key={ 'filter-sd-drop-' +
                        this.filterFormStore.getValue('election_id') +
                        this.filterFormStore.getValue('election_position_id') +
                        this.filterFormStore.getValue('user_party_id') +
                        this.filterFormStore.getValue('level') +
                        this.filterFormStore.getValue('state_id')
                    }
                    name="senatorial_district_id"
                    placeholder="Select Senatorial Districts"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.senatorialDistrict.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_id: this.filterFormStore.getValue('election_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidateIds'),
                                party_id: this.filterFormStore.getValue('user_party_id'),
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={() => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col>: ''
    }

    federalConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'federal_constituency' ?
            <Col md={2} lg={3} xl>
                <Field
                    key={ 'filter-fc-drop-' +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('user_party_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id')
                    }
                    name="federal_constituency_id"
                    placeholder="Select Federal Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.federalConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_id: this.filterFormStore.getValue('election_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidateIds'),
                                party_id: this.filterFormStore.getValue('user_party_id'),
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col>: ''
    }

    stateConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'state_constituency' ?
            <Col md={2} lg={3} xl>
                <Field
                    key={ 'filter-sc-drop-' +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('user_party_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id')
                    }
                    name="state_constituency_id"
                    placeholder="Select State Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.stateConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_id: this.filterFormStore.getValue('election_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidateIds'),
                                party_id: this.filterFormStore.getValue('user_party_id'),
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                    }}
                />
            </Col>: ''
    }


    colums() {
        return [
		    {
                name: "polling_unit.station_number",
                label: "Station Number",
                sortColumn: 'station_number',
                sort: true,
            },
            {
                name: "polling_unit.state.code",
                label: "State Code",
                sort: true,
                sortColumn: 'state.code',
            },
            {
                name: "polling_unit.state.name",
                label: "State",
                sort: true,
                sortColumn: 'state.name',
            },
            {
                name: "polling_unit.local_government_area.code",
                label: "LGA Code",
                sort: true,
                sortColumn: 'local_government_area.code',
            },
            {
                name: "polling_unit.local_government_area.name",
                label: "LGA",
                sort: true,
                sortColumn: 'local_government_area.name',
            },
            {
                name: "polling_unit.ward.code",
                label: "Ward Code",
                sort: true,
                sortColumn: 'ward.code',
            },
            {
                name: "polling_unit.ward.name",
                label: "Ward",
                sort: true,
                sortColumn: 'ward.name',
            },
            {
                name: "code",
                label: "Polling Unit Code",
                sort: true,
                sortColumn: 'code',
            },
            {
                name: "name",
                label: "Polling Unit Name",
                sort: true,
                sortColumn: 'name',
            },
            {
                name: "registered_voters",
                label: "INEC Reg. Voters",
                sort: true,
                sortColumn: 'registered_voters',
            },
			{
                name: "polling_unit.pvc_register_voters",
                label: "PVC Collected",
                sort: true,
                sortColumn: 'pvc_register_voters',
            },
			/* {
                name: "pusers",
                label: "Agent Assigned",
                sort: true,
                sortColumn: 'pusers',
				formatter: (value: any, item: any) => {  
					return ( 
						<>						
								{value > 0 ? 'Yes' : 'No'}
							
						</>
					);
				},
            }, */
			/* {
                name: "noofvotescount",
                label: "Result Submitted",
                sort: true,
                sortColumn: 'noofvotescount',
				formatter: (value: any, item: any) => {  
					return ( 
						<>						
								{value > 0 ? 'Yes' : 'No'}
							
						</>
					);
				},
            },	 */		
			{
                name: "registered_voters",
                label: "Submit Result",
				formatter: (value: any, item: any) => {  
                return ( 
                    <>		
                            <Button color="grid" /* onClick={() => this.props.onAdd()} */ onClick={() => this.addUser(item)} size="sm"
                                    className="btn btn-positions"><span className="icon-users"/></Button> 
                        
                    </>
                );
            },
				
            },
        ];
    }
	addUser(item: any)
	{
		console.log("data" , item);
		window.localStorage.setItem('level', 'polling_unit');
		window.localStorage.setItem('election_id', item.election_id);
		window.localStorage.setItem('election_position_id', item.election_position_id);
		
//		election_polling_unit_id
		
		window.localStorage.setItem('state_id', item.polling_unit.state_id);
		
		window.localStorage.setItem('ward_id', item.polling_unit.ward.id);
		window.localStorage.setItem('local_government_area_id', item.polling_unit.local_government_area.id);
		
		 
		window.localStorage.setItem('ward', item.polling_unit.ward.name);
		
		window.localStorage.setItem('polling_unit', item.polling_unit.name);
		window.localStorage.setItem('polling_unit_id', item.polling_unit_id);
		// window.localStorage.setItem('election_polling_unit_id', item.polling_unit_id);
		// window.localStorage.setItem('party_id', item.polling_unit_id);
		
		
		this.props.onAdd();
	}

    idColumn() {
        return '';
    }

    /*  actions() {
        return ''
    }  */

    getUserPopup() {
       // console.log('click pressed');
        
        
        
     }

     defaultActions() {
		
        return {
            name: "id",
            label: "Actions",
            formatter: (value: any) => {  
                return ( 
                    <>
                        
			
                            
                        
                    </>
                );
            },
            style: {whiteSpace: 'nowrap', textAlign: 'center', display: 'none'},
        } 
    }

	handleExport = () => {
        let search = {
            filters: this.filterFormStore.data,
            export: true
        };
        window.location.href = '/api/party/polling-units?' + qs.stringify(search);
    };	

    renderTable() {
        if (this.filterFormStore.getValue('election_id')){
            return super.renderTable();
        }
        return <>{'Please select election first!'}</>;
    }

    onLoadElections = () => {
        return api.election.getListAction({
            filters: {
                party_id: this.filterFormStore.getValue('user_party_id'),
            }
        }).then((data: any) => {
            if (data && data.length) {
                this.filterFormStore.setValue('election_id', data[0].id);
            }
            return data;
        });
    };

    onLoadElectionPosition = () => {
        return this.filterFormStore.getValue('election_id')  && api.electionPosition.getListAction({
            filters: {
                election_id: this.filterFormStore.getValue('election_id'),
                party_id: this.filterFormStore.getValue('user_party_id')
            }
        }).then((data: any) => {
            if (data && data.length) {
                this.filterFormStore.setValue('election_position_id', data[0].id);
                this.filterFormStore.setValue('level', data[0].level);
            }
            return data;
        });
    }

    renderFilters() {
        return (
            <Container>
			<Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
                <Row className="form-row">
                    <Col md={2} lg={3} xl>
                        <Field
                            key={'filer-election-' +
                                IWindow.initialState.user.party_id
                            }
                            placeholder="Select Election"
                            name="election_id"
                            component={Select}
                            required={true}
                            loadOptions={this.onLoadElections}
                            store={this.filterFormStore} 
                            onChange={(value: any) => {
                                this.getElectionDetails(value);
                                this.filterFormStore.setValue('level', null);
                                this.filterFormStore.setValue('election_position_id', null);
                                this.getCandidates();
                            }}
                        />
                    </Col>
                    { this.filterFormStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'filer-election-position' +
                                this.filterFormStore.getValue('election_id')  +
                                this.filterFormStore.getValue('user_party_id')
                            }
                            placeholder="Position"
                            name="election_position_id"
                            component={Select}
                            required={true}
                            loadOptions={this.onLoadElectionPosition}
                            store={this.filterFormStore}
                            returnObject={true}
                            extraKey={'level'}
                            onChange={(item: any) => {
                                this.filterFormStore.setValue('level', null);
                                if(item){
                                    this.filterFormStore.setValue('level', item.extraKey);
                                }
                                this.filterFormStore.setValue('state_id', null);
                                this.filterFormStore.setValue('senatorial_district_id', null);
                                this.filterFormStore.setValue('federal_constituency_id', null);
                                this.filterFormStore.setValue('local_government_area_id', null);
                                this.filterFormStore.setValue('state_constituency_id', null);
                                this.filterFormStore.setValue('ward_id', null);
                            }}
                        />
                    </Col>
                    : '' }
                    {
                        this.filterFormStore.getValue('election_position_id') ?
                            <>

                                {
                                    this.filterFormStore.getValue('level') != "senatorial_district" &&
                                    this.filterFormStore.getValue('level') != "federal_constituency" &&
                                    this.filterFormStore.getValue('level') != "polling_unit" &&
                                    this.filterFormStore.getValue('level') != "state_constituency" ?
                                    <Col md={2}>
                                        <Field
                                            key={'filer-state-dp' +
                                                this.filterFormStore.getValue('election_id') +
                                                this.filterFormStore.getValue('user_party_id') +
                                                this.filterFormStore.getValue('election_position_id')
                                            }
                                            name="state_id"
                                            placeholder="Select State"
                                            component={Select}
                                            loadOptions={() => {
                                                return api.state.getListAction({
                                                    filters: {
                                                        election_id: this.election ? this.election.id : this.filterFormStore.getValue('election_id'),
                                                        election_position_id: this.filterFormStore.getValue('election_position_id'),
                                                        party_id: this.filterFormStore.getValue('user_party_id'),
                                                        level: this.filterFormStore.getValue('level'),
                                                        candidateIds: this.filterFormStore.getValue('candidateIds'),
                                                    }
                                                });
                                            }}
                                            store={this.filterFormStore}
                                            onChange={() => {
                                                this.filterFormStore.setValue('senatorial_district_id', null);
                                                this.filterFormStore.setValue('federal_constituency_id', null);
                                                this.filterFormStore.setValue('local_government_area_id', null);
                                                this.filterFormStore.setValue('state_constituency_id', null);
                                                this.filterFormStore.setValue('ward_id', null);
                                            }}
                                        />
                                    </Col> : ''}

                                {
                                    this.filterFormStore.getValue('level') ?
                                        <>
                                            {this.senatorialDistrictDropDown()}

                                            {this.federalConstituencyDropDown()}
                                        </> : ''
                                }
                                {
                                    this.filterFormStore.getValue('level') &&
                                    this.filterFormStore.getValue('level') !== 'state_constituency' &&
                                    this.filterFormStore.getValue('level') !== 'polling_unit'  ?
                                        <Col md={2}>
                                            <Field
                                                key={'filter-lga-id' +
                                                this.filterFormStore.getValue('election_id') +
                                                this.filterFormStore.getValue('election_position_id') +
                                                this.filterFormStore.getValue('user_party_id') +
                                                this.filterFormStore.getValue('state_id') +
                                                this.filterFormStore.getValue('senatorial_district_id') +
                                                this.filterFormStore.getValue('federal_constituency_id')
                                                }
                                                name="local_government_area_id"
                                                placeholder="Select LGA"
                                                component={Select}
                                                loadOptions={() => {
                                                    return api.localGovernmentArea.getListAction({
                                                        filters: {
                                                            election_id: this.election ? this.election.id : this.filterFormStore.getValue('election_id'),
                                                            state_id: this.filterFormStore.getValue('state_id'),
                                                            senatorial_district_id: this.filterFormStore.getValue('senatorial_district_id'),
                                                            federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
                                                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                                                            level: this.filterFormStore.getValue('level'),
                                                            party_id: this.filterFormStore.getValue('user_party_id'),
                                                            candidateIds: this.filterFormStore.getValue('candidateIds'),
                                                        }
                                                    });
                                                }}
                                                store={this.filterFormStore}
                                                onChange={() => {
                                                    this.filterFormStore.setValue('ward_id', null);
													
                                                }}
                                            />
                                        </Col> : ''
                                }

                                {
                                    this.filterFormStore.getValue('level') &&
                                    this.filterFormStore.getValue('level') === 'state_constituency' ?
                                        <>
                                            {this.stateConstituencyDropDown()}
                                        </> : ''
                                }
                                
                                {
                                    this.filterFormStore.getValue('level') &&
                                    <Col md={2}>
                                        <Field
                                            key={"filter-ward-id" +
                                            this.filterFormStore.getValue('election_id') +
                                            this.filterFormStore.getValue('election_position_id') +
                                            this.filterFormStore.getValue('user_party_id') +
                                            this.filterFormStore.getValue('level') +
                                            this.filterFormStore.getValue('state_id') +
                                            this.filterFormStore.getValue('local_government_area_id') +
                                            this.filterFormStore.getValue('state_constituency_id')
                                            }
                                            name="ward_id"
                                            placeholder="Select Ward"
                                            component={Select}
                                            loadOptions={() => {
                                                return api.ward.getListAction({
                                                    filters: {
                                                        state_id: this.filterFormStore.getValue('state_id'),
                                                        local_government_area_id: this.filterFormStore.getValue('local_government_area_id'),
                                                        state_constituency_id: this.filterFormStore.getValue('state_constituency_id'),
                                                        election_position_id: this.filterFormStore.getValue('election_position_id'),
                                                        level: this.filterFormStore.getValue('level'),
                                                        party_id: this.filterFormStore.getValue('user_party_id'),
                                                        candidateIds: this.filterFormStore.getValue('candidateIds'),
                                                        no_position: ( this.filterFormStore.getValue('level') === 'polling_unit') ? 1 : null,
                                                    }
                                                });
                                            }}
                                            store={this.filterFormStore}
                                        />
                                    </Col>
                                }
                                

                            </> : ''
                    }
                    <Col md={2} lg={3} xl className="grid-search">
                        {this.renderSearch()}
                    </Col>
					
                </Row>
            </Container>
        );
    }
}

export class PartyElectionPollingUnitResultPage extends CrudPage {
    modelName = 'PartyElectionPollingUnitResult';
    actionButton = false;
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/PartyElectionPollingUnitResultPage.tsx